import {
  Snowflake,
  Flame,
  Thermometer,
  Wind,
  Wrench,
  Building2,
  ArrowUpRight,
} from "lucide-react";

const SERVICES = [
  {
    id: "ac",
    icon: Snowflake,
    title: "AC Install & Repair",
    desc: "Lennox-certified installations, fast cooling repairs and seasonal tune-ups to keep summers comfortable.",
  },
  {
    id: "heating",
    icon: Flame,
    title: "Heating & Furnaces",
    desc: "High-efficiency Lennox furnaces, gas and electric heating system installations, repair and replacement.",
  },
  {
    id: "heatpumps",
    icon: Thermometer,
    title: "Heat Pumps",
    desc: "Year-round comfort with energy-efficient Lennox heat pump systems designed for Kansas climates.",
  },
  {
    id: "iaq",
    icon: Wind,
    title: "Indoor Air Quality",
    desc: "Air purifiers, humidifiers, ventilation and filtration to keep your family breathing clean.",
  },
  {
    id: "maintenance",
    icon: Wrench,
    title: "Preventive Maintenance",
    desc: "Twice-a-year tune-ups that extend equipment life, reduce energy bills, and prevent breakdowns.",
  },
  {
    id: "commercial",
    icon: Building2,
    title: "Commercial HVAC",
    desc: "Rooftop units, light commercial installs and service contracts for Hiawatha businesses.",
  },
];

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="py-20 sm:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-14">
          <div className="text-xs font-semibold uppercase tracking-widest text-[#E31837] mb-3">
            What we do
          </div>
          <h2 className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-slate-900">
            Full-service HVAC, built around Lennox quality.
          </h2>
          <p className="mt-5 text-lg text-slate-600 leading-relaxed">
            From new installs to emergency repairs, our team handles every home and
            business comfort need across Brown County and beyond.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s) => {
            const Icon = s.icon;
            return (
              <div
                key={s.id}
                data-testid={`service-card-${s.id}`}
                className="group relative bg-white rounded-3xl p-8 border border-slate-100 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_20px_50px_rgb(0,0,0,0.08)] hover:-translate-y-1 transition-all duration-300"
              >
                <div className="w-14 h-14 rounded-2xl bg-slate-900 group-hover:bg-[#E31837] transition-colors flex items-center justify-center mb-6">
                  <Icon className="w-7 h-7 text-white" strokeWidth={2} />
                </div>
                <h3 className="font-display font-bold text-xl text-slate-900 mb-2 tracking-tight">
                  {s.title}
                </h3>
                <p className="text-slate-600 leading-relaxed">{s.desc}</p>
                <button
                  onClick={() =>
                    document.getElementById("booking")?.scrollIntoView({ behavior: "smooth" })
                  }
                  data-testid={`service-cta-${s.id}`}
                  className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-slate-900 group-hover:text-[#E31837] transition-colors"
                >
                  Request service
                  <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
